import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'
import { tween } from 'shifty'

class MobileMenuSection extends Section {
  initState() {
    return {
      display: false
    }
  }

  init() {
    this.computed(() => this.displayChanged(this.state.display))
    on('mobilemenu:toggle', () => this.toggle())
    on(this.refs.close, 'click', () => this.toggle())

    if (this.refs.toggleSub?.length) {
      this.refs.toggleSub.forEach((el) => {
        on(el, 'click', () => {
          const index = this.refs.toggleSub.indexOf(el)
          this.refs.subs.forEach((el, i) => {
            if (i === index) {
              if (el.dataset.active === '1') {
                this.tweenSubClose(el, i)
              }
              else {
                this.tweenSubOpen(el, i)
              }
            }
            else {
              this.tweenSubClose(el, i)
            }
          })
        })
      })
    }
  }

  tweenSubOpen(el, i) {
    this.refs.toggleSub[i].dataset.active = 1
    el.style.height = 'auto'
    const height = el.offsetHeight
    tween({
      easing: 'easeInOutQuad',
      duration: 300,
      from: { value: 0 },
      to: { value: height },
      render: ({ value }) => {
        el.style.height = `${value}px`
      }
    }).then(() => {
      el.style.height = null
      el.dataset.active = 1
    })
  }

  tweenSubClose(el, i) {
    this.refs.toggleSub[i].dataset.active = 0
    tween({
      easing: 'easeInOutQuad',
      duration: 300,
      from: { value: el.offsetHeight },
      to: { value: 0 },
      render: ({ value }) => {
        el.style.height = `${value}px`
      }
    }).then(() => {
      el.style.height = null
      el.dataset.active = 0
    })
  }

  toggle() {
    this.state.display = !this.state.display
  }

  displayChanged(value) {
    this.el.dataset.display = value ? 1 : 0

    if (!value) {
      if (this.refs.subs?.length) {
        this.refs.subs.forEach((el, i) => {
          this.tweenSubClose(el, i)
        })
      }
    }
  }
}

register('mobilemenu', MobileMenuSection)
